import NewTabIcon from '../assets/sidebarIcons/newTab.svg';
import ArticlesIcon from '../assets/sidebarIcons/articles.svg';
import ArticlesBlueIcon from '../assets/sidebarIcons/articlesBlue.svg';
import GalleryIcon from '../assets/sidebarIcons/gallery.svg';
import GalleryBlueIcon from '../assets/sidebarIcons/galleryBlue.svg';
import ReportsIcon from '../assets/sidebarIcons/reports.svg';
import ReportsBlueIcon from '../assets/sidebarIcons/reportsBlue.svg';
import UsersIcon from '../assets/sidebarIcons/users.svg';
import UsersBlueIcon from '../assets/sidebarIcons/usersBlue.svg';
import OrganizationsIcon from '../assets/sidebarIcons/organizations.svg';
import OrganizationsBlueIcon from '../assets/sidebarIcons/organizationsBlue.svg';
import EventsIcon from '../assets/sidebarIcons/events.svg';
import EventsBlueIcon from '../assets/sidebarIcons/eventsBlue.svg';
import CategoriesIcon from '../assets/sidebarIcons/categories.svg';
import CategoriesBlueIcon from '../assets/sidebarIcons/categoriesBlue.svg';
import AdminsIcon from '../assets/sidebarIcons/admins.svg';
import AdminsBlueIcon from '../assets/sidebarIcons/adminsBlue.svg';
import CitiesIcon from '../assets/sidebarIcons/cities.svg';
import CitiesBlueIcon from '../assets/sidebarIcons/citiesBlue.svg';
import OperationsIcon from '../assets/sidebarIcons/operations.svg';
import OperationsBlueIcon from '../assets/sidebarIcons/operationsBlue.svg';
import NotificationsIcon from '../assets/sidebarIcons/notifications.svg';
import NotificationsBlueIcon from '../assets/sidebarIcons/notificationsBlue.svg';
import PaymentsIcon from '../assets/sidebarIcons/payment.svg';
import PaymentsBlueIcon from '../assets/sidebarIcons/paymentBlue.svg';
import StatisticsIcon from '../assets/sidebarIcons/statistics.svg';
import StatisticsBlueIcon from '../assets/sidebarIcons/statisticsBlue.svg';
import Articles from '../pages/Articles';
import Gallery from '../pages/Gallery';
import Reports from '../pages/Reports';
import Users from '../pages/Users';
import Organizations from '../pages/Organizations';
import Admins from '../pages/Admins';
import Cities from '../pages/Cities';
import AddOrganization from '../pages/AddOrganization';
import BulkAddOrganizations from '../pages/BulkAddOrganizations';
import EditOrganizationPhotos from '../pages/EditOrganizationPhotos';
import Categories from '../pages/Categories';
import ViewSingleOrganization from '../pages/ViewSingleOrganization';
import Events from '../pages/Events';
import AddEvent from '../pages/AddEvent';
import ViewSingleEvent from '../pages/ViewSingleEvent';
import EditEventPhotos from '../pages/EditEventPhotos';
import TemplatePhotos from '../pages/TemplatePhotos';
import Operations from '../pages/Operations';
import ViewSingleOperation from '../pages/ViewSingleOperation';
import NewOperation from '../pages/NewOperation';
import Notifications from '../pages/Notifications';
import Payments from '../pages/Payments';
import ViewSinglePayment from '../pages/ViewSinglePayment';
import PaymentSettings from '../pages/PaymentSettings';
import ScreenTimeStatistics from '../pages/ScreenTimeStatistics';

export const SidebarData = {
  cities: {
    title: 'Города',
    path: '/cities',
    icon: CitiesIcon,
    selectedIcon: CitiesBlueIcon,
    component: <Cities />,
  },
  articles: {
    title: 'Статьи',
    path: '/articles',
    icon: ArticlesIcon,
    selectedIcon: ArticlesBlueIcon,
    component: <Articles />,
  },
  gallery: {
    title: 'Галерея',
    path: '/gallery',
    icon: GalleryIcon,
    selectedIcon: GalleryBlueIcon,
    component: <Gallery />,
    target: '_blank',
    rightIcon: NewTabIcon,
  },
  templatePhotos: {
    title: 'Шаблонные фото',
    path: '/template-photos',
    icon: GalleryIcon,
    selectedIcon: GalleryBlueIcon,
    component: <TemplatePhotos />,
    target: '_blank',
    rightIcon: NewTabIcon,
  },

  reports: {
    title: 'Репорты',
    path: '/reports',
    icon: ReportsIcon,
    selectedIcon: ReportsBlueIcon,
    component: <Reports />,
  },
  users: {
    title: 'Пользователи',
    path: '/users',
    icon: UsersIcon,
    selectedIcon: UsersBlueIcon,
    component: <Users />,
  },
  organizations: {
    title: 'Предложения',
    path: '/organizations',
    pathPrefixes: [
      { path: '/view', component: <Organizations /> },
      { path: '/single-view', component: <ViewSingleOrganization /> },
      { path: '/create', component: <AddOrganization /> },
      { path: '/bulk-create', component: <BulkAddOrganizations /> },
      { path: '/edit', component: <AddOrganization /> },
      { path: '/edit-photos', component: <EditOrganizationPhotos /> },
    ],
    icon: OrganizationsIcon,
    selectedIcon: OrganizationsBlueIcon,
  },
  events: {
    title: 'Мероприятия',
    path: '/events',
    pathPrefixes: [
      { path: '/view', component: <Events /> },
      { path: '/single-view', component: <ViewSingleEvent /> },
      { path: '/create', component: <AddEvent /> },
      { path: '/edit', component: <AddEvent /> },
      { path: '/edit-photos', component: <EditEventPhotos /> },
    ],
    icon: EventsIcon,
    selectedIcon: EventsBlueIcon,
  },
  categories: {
    title: 'Категории',
    path: '/categories',
    icon: CategoriesIcon,
    selectedIcon: CategoriesBlueIcon,
    component: <Categories />,
  },
  admins: {
    title: 'Администраторы',
    path: '/admins',
    icon: AdminsIcon,
    selectedIcon: AdminsBlueIcon,
    component: <Admins />,
  },
  operations: {
    title: 'Операции',
    path: '/operations',
    pathPrefixes: [
      { path: '/view', component: <Operations /> },
      { path: '/single-view', component: <ViewSingleOperation /> },
      { path: '/new-operation', component: <NewOperation /> },
    ],
    icon: OperationsIcon,
    selectedIcon: OperationsBlueIcon,
  },
  notifications: {
    title: 'Уведомления',
    path: '/notifications',
    icon: NotificationsIcon,
    selectedIcon: NotificationsBlueIcon,
    component: <Notifications />,
  },
  payments: {
    title: 'Платежи',
    path: '/payments',
    pathPrefixes: [
      { path: '/view', component: <Payments /> },
      { path: '/single-view', component: <ViewSinglePayment /> },
      { path: '/settings', component: <PaymentSettings /> },
    ],
    icon: PaymentsIcon,
    selectedIcon: PaymentsBlueIcon,
  },
  statistics: {
    title: 'Статистика',
    path: '/statistics',
    icon: StatisticsIcon,
    selectedIcon: StatisticsBlueIcon,
    component: <ScreenTimeStatistics />,
  },
};
